'use strict';

angular.module('selfAccessRequestControllers')

.controller('ArrivalSameAsSystemTypeListController',
            ['$scope', '$state', '$stateParams', 'selfAccessRequestService', 'decisionSystemTypesList',
    function ($scope, $state, $stateParams, selfAccessRequestService, decisionSystemTypesList) {

        // Return if we are not in the right state
        if (!$state.is('selfAccessRequest.arrival.sameAs')) return;

        // If no decisions inside the list return
        if (_.size(decisionSystemTypesList) === 0) return;

        // Go to State selected
        $state.go('selfAccessRequest.arrival.sameAsBySystemType', {
            systemTypeSlug: decisionSystemTypesList[0].Slug,
            sameAsEmployeeID: $stateParams.sameAsEmployeeID
        }, { location: 'replace' });

    }]);